<template>
  <v-ons-page id="app" style="font-family: 'Noto Sans JP', sans-serif;">
    <v-ons-splitter>
      <!-- <v-ons-splitter-side swipeable collapse width="250px" side="right" -->
      <v-ons-splitter-side collapse width="250px" side="right"
        :animation="$ons.platform.isAndroid() ? 'overlay' : 'reveal'"
        :open.sync="menuIsOpen">
        <menu-page></menu-page>
      </v-ons-splitter-side>

      <v-ons-splitter-content>
        <transition :name="slideDirection" mode="in-out" appear>
          <router-view></router-view>
        </transition>
      </v-ons-splitter-content>
    </v-ons-splitter>
  </v-ons-page>
</template>

<script>
import AppView from './components/AppView'
import MenuPage from './components/MenuPage'

export default {
  name: 'app',
  computed: {
    slideDirection: {
      get () {
        // return 'slide'
        // return 'back'
        return this.$store.state.routerAnim.anim
      }
    },
    menuIsOpen: {
      get () {
        return this.$store.state.splitter.open
      },
      set (newValue) {
        this.$store.commit('splitter/toggle', newValue)
      }
    }
  },
  components: {
    MenuPage,
    AppView
  },

  mounted () {
    this.$ons.ready(() => {
      // prefersDark.matches=trueの場合、ダークモード
      const prefersDark = window.matchMedia('(prefers-color-scheme: dark)')
      // 現在のモードに変更
      this.changeTheme(prefersDark.matches)
      // モードの変更を検知
      prefersDark.addListener((mediaQuery) => this.changeTheme(mediaQuery.matches))
    })
  },
  methods: {
    changeTheme (dark) {
      // モードに応じて、CSSファイルを変更
      if (dark) {
        document.getElementById('theme-css').setAttribute('href', 'dark-commu-onsen-css-components.css')
        if (this.$ons.isWebView()) {
          window.StatusBar.styleLightContent()
          window.StatusBar.backgroundColorByHexString('#181818')
          window.plugins.webviewcolor.change('#0d0d0d')
        }
      } else {
        document.getElementById('theme-css').setAttribute('href', 'commu-onsen-css-components.css')
        if (this.$ons.isWebView()) {
          window.StatusBar.styleDarkContent()
          window.StatusBar.backgroundColorByHexString('#fafafa')
          window.plugins.webviewcolor.change('#efeff4')
        }
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
/* @import url('https://fonts.googleapis.com/css?family=Noto+Sans+JP&subset=japanese');

body {
  font-family: 'Noto Sans JP', sans-serif;
} */

.slide-enter-active, .slide-leave-active {
  transition: transform .5s
}
.slide-enter {
  transform: translateX(100%)
}
.slide-leave-active {
  transform: translateX(-30%)
}
.back-enter-active, .slide-leave-active {
  transition: transform .5s
}
.back-enter {
  transform: translateX(-100%)
}
.back-leave-active {
  transform: translateX(100%)
}
ons-splitter-side[side=right][animation=overlay] {
  border-right: 1px solid #BBB;
}
</style>



// WEBPACK FOOTER //
// src/App.vue